import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { UnsavedChangesDialogComponent } from './unsaved-changes-dialog.component';

@Injectable()
export class UnsavedChangesDialogService {
  constructor(private dialog: MatDialog) {}

  public open(): Observable<boolean> {
    let dialogRef: MatDialogRef<UnsavedChangesDialogComponent>;
    dialogRef = this.dialog.open(UnsavedChangesDialogComponent, {
      maxWidth: '100vw',
    });
    return dialogRef.afterClosed();
  }
}
